import { useCallback } from "react";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQueryClient } from "@tanstack/react-query";
import { LANDING_HOME_URL } from "@/shared/config/marketingUrls";
import { beginLogoutInFlight, cancelLogoutInFlight } from "@/shared/lib/logoutInFlight";
import { resetStates } from "@/shared/lib/utils";

export function useAppLogout() {
  const { logout } = useKindeAuth();
  const queryClient = useQueryClient();

  return useCallback(() => {
    resetStates();
    queryClient.clear();
    beginLogoutInFlight();
    void Promise.resolve(logout({ redirectUrl: LANDING_HOME_URL })).catch((error) => {
      cancelLogoutInFlight();
      console.error("Logout failed", error);
    });
  }, [logout, queryClient]);
}
